import * as tslib_1 from "tslib";
import { Validator } from 'breeze-client';
import { LocalisationService } from '../../../core/localisation.service';
import { CurrencyValidator, NAME_CURRENCY_VALIDATOR } from '../../../core/validators/currency.validator';
import { InputBase } from '../input-base/input-base';
/**
 * Class for the number currency component
 */
var InputCurrencyComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputCurrencyComponent, _super);
    /**
     * Creates an instance of InputCurrencyComponent.
     * @memberOf InputCurrencyComponent
     */
    function InputCurrencyComponent(localisationService) {
        var _this = _super.call(this) || this;
        _this.decimalSeparator = localisationService.currentLanguage.formats.decimal;
        return _this;
    }
    Object.defineProperty(InputCurrencyComponent.prototype, "stringValue", {
        /**
         * Gets or sets the displayed value and converts it to the real value.
         * @type {string}
         * @memberOf InputCurrencyComponent
         */
        get: function () {
            return this._stringValue;
        },
        set: function (value) {
            this._stringValue = value;
            this.value = value ? Number.parseFloat(value) : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Cancels the input when the user pressed an invalid key.
     * @param {any} event The parameters contains the pressed key.
     * @returns {boolean} True if the user pressed a numeric character, period, comma, backspace, delete, or arrow left/right.
     * @memberOf InputCurrencyComponent
     */
    InputCurrencyComponent.prototype.validateKey = function (event) {
        return event.key === 'Delete' ||
            event.key === 'Backspace' ||
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowRight' ||
            event.key === '.' ||
            /\d/.test(event.key);
    };
    /**
     * Sets the displayed string value as well as the real value.
     * @param {*} val
     * @memberOf InputCurrencyComponent
     */
    InputCurrencyComponent.prototype.setValue = function (val) {
        this._stringValue = val ? val.toString() : null;
        _super.prototype.setValue.call(this, val);
    };
    /**
     * Validates a new value with the currency validator.
     * @protected
     * @param {*} newValue The new value
     * @returns {ValidationErrors} has errors if value is false
     * @memberOf InputCurrencyComponent
     */
    InputCurrencyComponent.prototype.isValidValue = function (newValue) {
        var _a;
        if (CurrencyValidator().validate(newValue)) {
            var errorKey = NAME_CURRENCY_VALIDATOR;
            return _a = {},
                _a[errorKey] = Validator.messageTemplates[errorKey],
                _a;
        }
        return null;
    };
    /**
     * The default angular control validator based upon the currency validator.
     * @protected
     * @returns {(ValidatorFn | ValidatorFn[])} An Angular control validator.
     * @memberOf InputCurrencyComponent
     */
    InputCurrencyComponent.prototype.defaultControlValidator = function () {
        var self = this;
        return function (c) {
            return self.isValidValue(c.value);
        };
    };
    return InputCurrencyComponent;
}(InputBase));
export { InputCurrencyComponent };
